import { ElectricCarControlChargingResponseModelV1StateEnum } from '@swagger-http';

import { LiveDataActionTypes, ElectricCarEventReason } from '@store/enums';
import { LiveDataState, LiveDataAction } from '@store/types';

const { Pending, Confirmed, Failed, Cancelled } =
    ElectricCarControlChargingResponseModelV1StateEnum;

export const initialState: LiveDataState = {
    telemetries: {
        emobility: {
            wallbox: {
                commandError: false, // will be true if e.g. virta cannot be reached for charging
                loading: true,
                isFinishing: false,
                evStateLoading: true,
            },
            electricCar: {
                commandError: false, // will be true if e.g. enode cannot be reached for charging
                loading: true,
                evStateLoading: true,
            },
        },
        pvbattery: {
            error: false,
            loading: true,
            telemetriesReceived: 0,
        },
        gcp: {
            error: false,
            loading: true,
            telemetriesReceived: 0,
        },
        dhw: {},
        compressor: {},
        notifications: {
            notifications: [],
            loading: false,
        },
        gatewayStatuses: {},
        heatpump: {
            powerConsumption: 0,
            loading: true,
            error: false,
        },
    },
};

export default function reducer(
    state: LiveDataState = initialState,
    action: LiveDataAction,
): LiveDataState {
    switch (action.type) {
        case LiveDataActionTypes.WALLBOX_TELEMETRIES:
            return {
                ...state,
                telemetries: {
                    ...state.telemetries,
                    emobility: {
                        ...state.telemetries.emobility,
                        wallbox: {
                            ...state.telemetries.emobility.wallbox,
                            ...action.payload,
                        },
                    },
                },
            };
        case LiveDataActionTypes.ELECTRIC_CAR_TELEMETRIES:
            return {
                ...state,
                telemetries: {
                    ...state.telemetries,
                    emobility: {
                        ...state.telemetries.emobility,
                        electricCar: {
                            ...state.telemetries.emobility.electricCar,
                            ...action.payload,
                        },
                    },
                },
            };
        case LiveDataActionTypes.UPDATE_ELECTRIC_CAR_TELEMETRIES:
            switch (action.payload.state) {
                case Pending:
                    return {
                        ...state,
                        telemetries: {
                            ...state.telemetries,
                            emobility: {
                                ...state.telemetries.emobility,
                                electricCar: {
                                    ...state.telemetries.emobility.electricCar,
                                    evStateLoading: true,
                                    isElectricCarSyncCharging:
                                        action.payload.reason ===
                                        ElectricCarEventReason.CatchPlugAndCharge,
                                },
                            },
                        },
                    };
                case Confirmed:
                    return {
                        ...state,
                        telemetries: {
                            ...state.telemetries,
                            emobility: {
                                ...state.telemetries.emobility,
                                electricCar: {
                                    ...state.telemetries.emobility.electricCar,
                                    evStateLoading: false,
                                    isElectricCarSyncCharging: false,
                                },
                            },
                        },
                    };
                case Cancelled:
                case Failed:
                    return {
                        ...state,
                        telemetries: {
                            ...state.telemetries,
                            emobility: {
                                ...state.telemetries.emobility,
                                electricCar: {
                                    ...state.telemetries.emobility.electricCar,
                                    evStateLoading: false,
                                    commandError: true,
                                    isElectricCarSyncCharging: false,
                                },
                            },
                        },
                    };
                default:
                    return state;
            }
        case LiveDataActionTypes.PVBATTERY_TELEMETRIES:
            return {
                ...state,
                telemetries: {
                    ...state.telemetries,
                    pvbattery: {
                        ...state.telemetries.pvbattery,
                        ...action.payload,
                        // prettier-ignore
                        telemetriesReceived: state.telemetries.pvbattery.telemetriesReceived + 1,
                    },
                },
            };
        case LiveDataActionTypes.GCP_TELEMETRIES:
            return {
                ...state,
                telemetries: {
                    ...state.telemetries,
                    gcp: {
                        ...state.telemetries.gcp,
                        ...action.payload,
                        loading: false,
                        // prettier-ignore
                        telemetriesReceived: state.telemetries.gcp.telemetriesReceived + 1,
                    },
                },
            };
        case LiveDataActionTypes.GATEWAY_STATUSES:
            return {
                ...state,
                telemetries: {
                    ...state.telemetries,
                    gatewayStatuses: action.payload,
                },
            };
        case LiveDataActionTypes.HEAT_PUMP_TELEMETRIES:
            return {
                ...state,
                telemetries: {
                    ...state.telemetries,
                    heatpump: {
                        ...state.telemetries.heatpump,
                        ...action.payload,
                        loading: false,
                    },
                },
            };
        default:
            return state;
    }
}
